import api from '../../../../api/api';

export const fetchBills = (startDate, endDate) => async dispatch => {
    dispatch({ type: 'BILLS_LOADING' });
    const response = await api.get(`/Bills/?startDate=${startDate}&endDate=${endDate}`);
    dispatch({ type: 'BILLS_INITIAL', data: response.data.data });
}
